import { memo, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

// Actions
import { setPage, setProviderFilter } from "redux/game/slice";

// Components
import SkeletonGameList from "components/molecules/SkeletonGameList";
import GameList from "components/organisms/GameList";

// Helpers
import { cacheImages } from "helpers/cacheImages";

// Hooks
import { useLoaderStore } from "stores/loader";

// Selectors
import * as gameSelectors from "redux/game/selectors";

// Types
import { useGamesRequest } from "features/games/fetchGames";
import useQueryParam from "../../hooks/useQueryParam";
import { GET_PARAMS } from "../../constants/popupConfig";
import { CategoryListContainer } from "./CategoryListContainer";
import { CATEGORIES_ENUMS } from "../../constants/navigation/categories";

const GameListContainer = () => {
  const dispatch = useDispatch();
  const games = useSelector(gameSelectors.games);
  const { take, page, providers, sort } = useSelector(gameSelectors.filter);
  const category = useSelector(gameSelectors.category);
  const lastPage = useSelector(gameSelectors.lastPage);
  const { id: tournamentId } = useParams();
  const { overlayLoading } = useLoaderStore();
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const didHydrateRef = useRef(false);
  const selectedProviders = providers;
  const { fetchGames, isLoading } = useGamesRequest();

  useEffect(() => {
    fetchGames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providers, category, sort, page]);

  useEffect(() => {
    if (didHydrateRef.current) {
      return;
    }

    if (
      providersQuery &&
      (!selectedProviders || selectedProviders.length === 0)
    ) {
      const arrayProviders = providersQuery.split(",").filter(Boolean);
      if (arrayProviders.length > 0) {
        dispatch(setProviderFilter(arrayProviders));
      }
    }
    if (!providersQuery) {
      dispatch(setProviderFilter(null));
    }

    didHydrateRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (games) {
      const covers = games.map(
        (game) =>
          `https://diswdgcu9cfva.cloudfront.net/covers2/${game.uuid}.webp`,
      );
      cacheImages(covers).catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Error caching game images:", error);
      });
    }
  }, [games]);

  const handleShowMore = () => {
    if (page < lastPage) {
      dispatch(setPage(page + 1));
    }
  };
  if (overlayLoading) {
    return <SkeletonGameList />;
  }

  if (
    (providers && providers.length > 0) ||
    providersQuery ||
    (category !== CATEGORIES_ENUMS.LOBBY && !!category) ||
    tournamentId
  ) {
    return (
      <GameList
        list={games}
        take={take}
        page={page}
        lastPage={lastPage}
        onShowMore={handleShowMore}
        isAutoLoading={!tournamentId}
        isLoading={isLoading}
        isOverlayLoading={false}
        tournamentId={tournamentId}
      />
    );
  }
  return <CategoryListContainer />;
};

export default memo(GameListContainer);
